import { useState } from 'react';
import UserRepository from '../infrastructure/UserRepository'; // Adjust the import path
import logo from '../assets/paletteUnité.jpg';

const Login = () => {
    const [pseudo, setPseudo] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault(); // Prevent form reload
        setIsLoading(true);
        setError('');

        const userRepository = new UserRepository();

        try {
            // Initialize the database
            await userRepository.init();

            // Perform login
            const user = await userRepository.login(pseudo, password);


            console.log('Login successful:', user);
            localStorage.setItem('user', JSON.stringify(user));

            window.location.href = `/edit/${user.id}`;
        } catch (err) {
            setError(err.message || 'An error occurred during login');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="bg-white">
            <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
                <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-green-700 dark:border-green-700">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <h1 className="text-xl font-bold leading-tight tracking-tight text-white md:text-2xl dark:text-white">
                            Connexion
                        </h1>
                        {error && <p className="text-red-500 text-sm">{error}</p>}
                        <form className="space-y-4 md:space-y-6" onSubmit={handleLogin}>
                            <div>
                                <label htmlFor="pseudo" className="block mb-2 text-sm font-medium text-white dark:text-white">
                                    Pseudo
                                </label>
                                <input
                                    type="text"
                                    name="pseudo"
                                    id="pseudo"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-green-700"
                                    placeholder="Pseudo"
                                    value={pseudo}
                                    onChange={(e) => setPseudo(e.target.value)}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    Mot de passe
                                </label>
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="••••••••"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-green-700"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className="w-full text-green-700 bg-white hover:bg-green-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-white dark:hover:bg-green-300"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Loading...' : 'Sign in'}
                            </button>
                        </form>
                        <small className="text-gray-300">
                            Si vous n'êtes pas responsable de section merci de quitter cette page
                        </small>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Login